<div class="lib-widget-setting-wrapper">
    <div class="settings-dialog">
        <div class="settings-header">
            <h2 class="settings-title">
                {{ "OICL_OPENBRIDGE.INSTRUMENT_FIELD.WIDGET.INSTRUMENT_FIELD" | translate }} {{ "OICL_OPENBRIDGE.INSTRUMENT_FIELD.WIDGET.SETTINGS" | translate }}
            </h2>
            <button mat-icon-button
                    [mat-dialog-close]="true"
                    aria-label="Close Button"
                    class="settings-close-btn">
                <fa-icon [icon]="'xmark'"></fa-icon>
            </button>
        </div>

        <div class="settings-content">
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ "OICL_OPENBRIDGE.INSTRUMENT_FIELD.WIDGET.TITLE" | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="widgetTitle">
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ 'OICL_OPENBRIDGE.INSTRUMENT_FIELD.WIDGET.WIDGET_HEADER_DISPLAY_OPTIONS' | translate }}</mat-label>
                    <mat-select [(value)]="selectedWidgetHeaderOption" (selectionChange)="selectHeaderOption($event)">
                        @for (option of (openBridgeInstrumentFieldWidget.settings.widgetHeader | keyvalue); track option.key) {
                            <mat-option [value]="option.key" [disabled]="option.key === 'alwaysOff' || option.key === 'transparent'">
                                {{ getText(option.key) }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="form-row toggle-row">
                <mat-slide-toggle class="primary" color="primary" [(ngModel)]="showWidgetTitle">
                    <span class="toggle-label">{{ 'OICL_OPENBRIDGE.INSTRUMENT_FIELD.WIDGET.SHOW_WIDGET_TITLE' | translate }}</span>
                </mat-slide-toggle>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ "OICL_OPENBRIDGE.INSTRUMENT_FIELD.WIDGET.MMSI" | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="selectedEntityIdPattern">
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ "OICL_OPENBRIDGE.INSTRUMENT_FIELD.WIDGET.INSTRUMENT_FIELD" | translate }} {{ "OICL_OPENBRIDGE.INSTRUMENT_FIELD.WIDGET.SELECT" | translate | lowercase }}</mat-label>
                    <mat-select [(ngModel)]="selectedInstrumentKey">
                        @for (instrument of instruments; track instrument){
                            <mat-option [value]=instrument>{{ DefaultInstruments[instrument].tag }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="settings-footer">
            <button mat-raised-button
                    type="button"
                    [mat-dialog-close]="true">
                {{ "OICL_OPENBRIDGE.INSTRUMENT_FIELD.WIDGET.CANCEL" | translate }}
            </button>
            <button mat-raised-button
                    class="primary"
                    type="submit"
                    (click)="onSubmit()">
                {{ "OICL_OPENBRIDGE.INSTRUMENT_FIELD.WIDGET.SAVE" | translate }}
            </button>
        </div>
    </div>
</div>
